/*
 * Pen Tech – search and filter helpers (v26).
 *
 * Search
 *  - Search keywords: maps the Arabic / Franco words shoppers type to the English
 *    words the catalog uses (theme setting "Search keywords"), before live search
 *    and before the full search page loads. The visitor's own words stay in the
 *    box (sent along as pt_q so the results page can show them again).
 *  - Adds options[fields] / options[unavailable_products] / options[prefix] to
 *    every storefront search request that lacks them (popular-search links too).
 *
 * Filters (collection and search pages)
 *  - One chip per grouped filter value ("16GB" instead of 10 raw RAM chips).
 *  - The product count in the page header follows the filters.
 *  - Arabic labels for Shopify's sort options.
 *
 * Settings and labels come from <script id="pt-search-config"> (snippets/pt-search-config.liquid).
 * Exposes window.PTSearch = { mapQuery, fields, unavailable, searchUrl, config, i18n }.
 */
(function () {
  'use strict';
  if (window.PTSearch) return;

  var ALLOWED_FIELDS = ['title', 'product_type', 'vendor', 'tag', 'variants.sku', 'variants.title', 'variants.barcode', 'body', 'author'];
  var DEFAULT_FIELDS = 'title,product_type,vendor,tag,variants.sku';
  var SEP = '[\\s,.;:/()+_\\-\u060C\u061B\u061F]';
  var ARABIC = /[\u0600-\u06FF]/;

  var cfg = null;
  var rules = null;
  var matcher = null;
  var decoder = null;

  /* ---------- config ---------- */

  function config() {
    if (cfg) return cfg;
    var el = document.getElementById('pt-search-config');
    var parsed = {};
    if (el) {
      try { parsed = JSON.parse(el.textContent) || {}; } catch (e) { parsed = {}; }
    }
    if (el || document.readyState !== 'loading') cfg = parsed;
    return parsed;
  }

  // Shopify may HTML-escape translations; make them plain text again
  function decode(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    decoder = decoder || document.createElement('textarea');
    decoder.innerHTML = s;
    return decoder.value;
  }

  function i18n(key) {
    var t = (config().i18n || {})[key];
    return t ? decode(String(t)) : '';
  }

  /* ---------- keywords ---------- */

  function clean(s) {
    return String(s == null ? '' : s)
      .replace(/[\u064B-\u065F\u0670\u0640]/g, '') // tashkeel + tatweel
      .replace(/[\u0660-\u0669]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); }) // Arabic-Indic digits
      .replace(/[\u06F0-\u06F9]/g, function (d) { return String(d.charCodeAt(0) - 0x06F0); }) // Persian digits
      .replace(/\s+/g, ' ')
      .trim();
  }

  // one character in, one character out, so match positions never shift
  function norm(s) {
    return s
      .toLowerCase()
      .replace(/[\u0622\u0623\u0625\u0671]/g, '\u0627') // alef forms -> bare alef
      .replace(/\u0629/g, '\u0647') // taa marbuta -> haa
      .replace(/[\u0649\u06CC]/g, '\u064A') // alef maqsura / Farsi yeh -> yeh
      .replace(/\u06A9/g, '\u0643'); // Farsi kaf -> kaf
  }

  function escapeRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function buildMatcher() {
    if (matcher !== null) return matcher;
    rules = {};
    var terms = [];
    String(config().keywords || '').split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line || line.charAt(0) === '#') return;
      var m = line.match(/^(.+?)\s*(?:=>|\u2192|=)\s*(.+)$/);
      if (!m) return;
      var to = clean(m[2]);
      if (!to) return;
      m[1].split('|').forEach(function (term) {
        term = norm(clean(term));
        if (term && !Object.prototype.hasOwnProperty.call(rules, term)) {
          rules[term] = to;
          terms.push(term);
        }
      });
    });
    if (!terms.length) {
      matcher = false;
      return matcher;
    }
    terms.sort(function (a, b) { return b.length - a.length; });
    // whole words only; an Arabic article «ال» in front is allowed (الشاشة -> monitor)
    matcher = new RegExp('(^|' + SEP + ')(\u0627\u0644)?(' + terms.map(escapeRe).join('|') + ')(?=' + SEP + '|$)', 'g');
    return matcher;
  }

  function mapQuery(q) {
    var original = clean(q);
    if (!original) return original;
    var re = buildMatcher();
    if (!re) return original;
    var hit = false;
    re.lastIndex = 0;
    var out = norm(original).replace(re, function (all, lead, article, term) {
      hit = true;
      return lead + rules[term];
    });
    if (!hit) return original;
    // The catalog is in English and Shopify needs every word to match, so an Arabic word
    // with no rule (e.g. "projector" + an Arabic brand name) would empty the results:
    // keep the mapped and Latin words only.
    var words = out.split(/\s+/).filter(function (w) { return w && !ARABIC.test(w); });
    return words.length ? words.join(' ') : out.replace(/\s+/g, ' ').trim();
  }

  /* ---------- search options ---------- */

  function fields() {
    var seen = [];
    String(config().fields || DEFAULT_FIELDS).toLowerCase().split(',').forEach(function (f) {
      f = f.trim();
      if (f && ALLOWED_FIELDS.indexOf(f) > -1 && seen.indexOf(f) === -1) seen.push(f);
    });
    return (seen.length ? seen : DEFAULT_FIELDS.split(',')).join(',');
  }

  function unavailable() {
    var u = String(config().unavailable || 'last').toLowerCase();
    return ['show', 'hide', 'last'].indexOf(u) > -1 ? u : 'last';
  }

  function searchPath() {
    var s = window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.search_url;
    return s || '/search';
  }

  function searchUrl(q, extra) {
    var p = new URLSearchParams();
    var raw = String(q == null ? '' : q).trim();
    var mapped = mapQuery(raw);
    p.set('q', mapped);
    if (mapped !== raw) p.set('pt_q', raw);
    if (extra) Object.keys(extra).forEach(function (k) { p.set(k, extra[k]); });
    p.set('options[prefix]', 'last');
    p.set('options[unavailable_products]', unavailable());
    p.set('options[fields]', fields());
    return searchPath() + '?' + p.toString();
  }

  function isSearchForm(form) {
    if (!form || form.nodeName !== 'FORM') return false;
    if ((form.getAttribute('method') || 'get').toLowerCase() !== 'get') return false;
    if (!form.querySelector('[name="q"]')) return false;
    var path;
    try {
      path = new URL(form.getAttribute('action') || window.location.href, window.location.href).pathname;
    } catch (e) {
      return false;
    }
    return /\/search\/?$/.test(path);
  }

  // Runs for real submits, form.submit() (Minimog's search button) and new FormData(form)
  function onFormData(e) {
    var form = e.target;
    var fd = e.formData;
    if (!fd || !isSearchForm(form)) return;
    var q = fd.get('q');
    if (typeof q === 'string') {
      var raw = q.trim();
      var mapped = mapQuery(raw);
      if (mapped && mapped !== raw) {
        fd.set('q', mapped);
        if (!fd.has('pt_q')) fd.set('pt_q', raw);
      }
    }
    if (!fd.has('options[fields]')) fd.set('options[fields]', fields());
    if (!fd.has('options[unavailable_products]')) fd.set('options[unavailable_products]', unavailable());
    if (!fd.has('options[prefix]')) fd.set('options[prefix]', 'last');
  }

  function ensureHidden(form, name, value) {
    var found = false;
    Array.prototype.forEach.call(form.querySelectorAll('input[type="hidden"]'), function (i) {
      if (i.name === name) found = true;
    });
    if (found) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  // Older browsers without the formdata event
  function onSubmitFallback(e) {
    var form = e.target;
    if (!isSearchForm(form)) return;
    var input = form.querySelector('[name="q"]');
    if (input) {
      var mapped = mapQuery(input.value);
      if (mapped && mapped !== input.value.trim()) input.value = mapped;
    }
    ensureHidden(form, 'options[fields]', fields());
    ensureHidden(form, 'options[unavailable_products]', unavailable());
    ensureHidden(form, 'options[prefix]', 'last');
  }

  if ('FormDataEvent' in window) {
    document.addEventListener('formdata', onFormData, true);
  } else {
    document.addEventListener('submit', onSubmitFallback, true);
  }

  function fixPopular(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-ps-item][data-ps-query]'), function (a) {
      a.href = searchUrl(a.getAttribute('data-ps-query'), { type: 'product' });
    });
  }

  // The visitor's own words (pt_q) for this results page, while they still map to q
  function currentOriginal() {
    var params = new URLSearchParams(window.location.search);
    var original = params.get('pt_q');
    var q = params.get('q');
    if (!original || !q || mapQuery(original) !== clean(q)) return '';
    return original.trim();
  }

  // Show the visitor's own words (e.g. «لابتوب») in the results-page box, not the mapped ones
  function prefillResults() {
    var original = currentOriginal();
    if (!original) return;
    var q = new URLSearchParams(window.location.search).get('q');
    Array.prototype.forEach.call(document.querySelectorAll('[data-pt-search-input]'), function (input) {
      if (clean(input.value) === clean(q)) input.value = original;
    });
  }

  // Search page: filters, sort and filter chips reload the grid by AJAX from the filter form /
  // chip links, which have no pt_q – carry it so the box keeps the visitor's words afterwards.
  function keepOriginal() {
    var original = currentOriginal();
    if (!original) return;
    var form = document.getElementById('CollectionFiltersForm');
    if (form && form.querySelector('[name="q"]') && !form.querySelector('[name="pt_q"]')) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'pt_q';
      input.value = original;
      form.appendChild(input);
    }
    Array.prototype.forEach.call(document.querySelectorAll('#ActiveFacets a[href]'), function (a) {
      var u;
      try { u = new URL(a.getAttribute('href'), window.location.href); } catch (e) { return; }
      var q = u.searchParams.get('q');
      if (!q || u.searchParams.has('pt_q') || mapQuery(original) !== clean(q)) return;
      u.searchParams.set('pt_q', original);
      a.setAttribute('href', u.pathname + u.search);
    });
  }

  /* ---------- filters ---------- */

  function pairKey(name, value) {
    return name + '\u0000' + value;
  }

  // filter.* pairs present in `current` but missing from `next`
  function removedPairs(current, next) {
    var counts = {};
    next.forEach(function (v, n) {
      var k = pairKey(n, v);
      counts[k] = (counts[k] || 0) + 1;
    });
    var out = [];
    current.forEach(function (v, n) {
      var k = pairKey(n, v);
      if (counts[k]) counts[k] -= 1;
      else if (n.indexOf('filter.') === 0) out.push(k);
    });
    return out;
  }

  function setChipLabel(chip, label) {
    var link = chip.querySelector('a');
    if (!link) return;
    var holder = link.querySelector('span') || link;
    Array.prototype.slice.call(holder.childNodes).forEach(function (node) {
      if (node.nodeType === 3) holder.removeChild(node);
    });
    holder.appendChild(document.createTextNode(label));
  }

  // Grouped filters (snippets/pentech-grouped-filter.liquid) tick several raw values at once.
  // Show one chip per group, labelled like the group, that removes the whole group.
  function groupChips() {
    var facets = document.getElementById('ActiveFacets');
    var form = document.getElementById('CollectionFiltersForm');
    if (!facets || !form || facets.hasAttribute('data-pt-grouped')) return;
    facets.setAttribute('data-pt-grouped', '');

    var groups = [];
    var index = {};
    Array.prototype.forEach.call(form.querySelectorAll('.pt-facet-group'), function (li) {
      var members = li.querySelectorAll('input[data-pt-filter-member]');
      var pairs = [];
      var active = false;
      Array.prototype.forEach.call(members, function (m) {
        if (!m.name) return;
        pairs.push(pairKey(m.name, m.value));
        if (m.checked) active = true;
      });
      if (!active || !pairs.length) return;
      var labelEl = li.querySelector('.m-facet--label');
      var g = { label: labelEl ? labelEl.textContent.trim() : '', pairs: pairs, chips: [] };
      pairs.forEach(function (k) { index[k] = g; });
      groups.push(g);
    });
    if (!groups.length) return;

    var current = new URLSearchParams(window.location.search);
    Array.prototype.forEach.call(facets.querySelectorAll('facet-remove'), function (chip) {
      if (chip.classList.contains('m-active-facets--item-remove-all')) return;
      var link = chip.querySelector('a[href]');
      if (!link) return;
      var next;
      try { next = new URL(link.getAttribute('href'), window.location.href).searchParams; } catch (e) { return; }
      var removed = removedPairs(current, next);
      for (var i = 0; i < removed.length; i++) {
        if (index[removed[i]]) {
          index[removed[i]].chips.push(chip);
          break;
        }
      }
    });

    var template = i18n('remove_group');
    groups.forEach(function (g) {
      if (!g.chips.length || !g.label) return;
      var keep = new URLSearchParams();
      current.forEach(function (v, n) {
        if (n === 'page' || index[pairKey(n, v)] === g) return;
        keep.append(n, v);
      });
      var qs = keep.toString();
      var first = g.chips[0];
      var link = first.querySelector('a');
      link.setAttribute('href', window.location.pathname + (qs ? '?' + qs : ''));
      if (template) link.setAttribute('aria-label', template.replace('__LABEL__', g.label));
      setChipLabel(first, g.label);
      for (var i = 1; i < g.chips.length; i++) {
        if (g.chips[i].parentNode) g.chips[i].parentNode.removeChild(g.chips[i]);
      }
    });
  }

  // Search pages: "Clear all" should keep the relevance options
  function fixClearAll() {
    var a = document.querySelector('#ActiveFacets .m-active-facets--remove-all');
    if (!a) return;
    var u;
    try { u = new URL(a.getAttribute('href'), window.location.href); } catch (e) { return; }
    if (!u.searchParams.has('q')) return;
    if (!u.searchParams.has('options[fields]')) u.searchParams.set('options[fields]', fields());
    if (!u.searchParams.has('options[unavailable_products]')) u.searchParams.set('options[unavailable_products]', unavailable());
    if (u.searchParams.get('sort_by') === '') u.searchParams.delete('sort_by');
    a.setAttribute('href', u.pathname + u.search);
  }

  // The header (pt-page-header) sits outside the re-rendered grid section, so its count went stale
  function updateCount() {
    var src = document.querySelector('[data-pt-filter-count]');
    if (!src) return;
    var text = src.getAttribute('data-pt-filter-count-text');
    if (!text) return;
    var header = document.querySelector('.pt-page-header__count');
    if (header) {
      if (!header.hasAttribute('aria-live')) {
        header.setAttribute('aria-live', 'polite');
        header.setAttribute('aria-atomic', 'true');
      }
      if (header.textContent.trim() !== text) header.textContent = text;
    }
    if (src.getAttribute('data-pt-filter-scope') !== 'collection') return;
    var sortBox = document.querySelector('.facest-filters-section [data-toolbar-sorting]');
    if (!sortBox) return;
    var badge = sortBox.querySelector('.pt-results-count');
    if (!badge) {
      badge = document.createElement('p');
      badge.className = 'pt-results-count';
      sortBox.insertBefore(badge, sortBox.firstChild);
      sortBox.classList.add('pt-has-count');
    }
    badge.textContent = text;
  }

  // Shopify's sort names stay English on /ar ("Most relevant", "Featured"…)
  function relabelSort() {
    var labels = config().sort;
    if (!labels) return;
    function label(value) {
      var t = labels[String(value || '').replace(/-/g, '_')];
      return t ? decode(String(t)) : '';
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-toolbar-sorting] option, [data-form-sorting] option'), function (o) {
      var t = label(o.value);
      if (t) o.textContent = t;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-toolbar-sorting] .m-select-custom--option[data-value]'), function (o) {
      var t = label(o.getAttribute('data-value'));
      if (t) o.textContent = t;
    });
    Array.prototype.forEach.call(document.querySelectorAll('.m-sortby-mobile--item[data-value]'), function (li) {
      var t = label(li.getAttribute('data-value'));
      var span = li.querySelector('span');
      if (t && span) span.textContent = t;
    });
    var select = document.querySelector('[data-toolbar-sorting] select') || document.querySelector('[data-form-sorting] select');
    if (!select || select.selectedIndex < 0) return;
    var current = label(select.options[select.selectedIndex].value);
    if (!current) return;
    var trigger = document.querySelector('[data-toolbar-sorting] .m-select-custom--trigger-text');
    if (trigger) trigger.textContent = current;
    Array.prototype.forEach.call(document.querySelectorAll('[data-sortby-option]'), function (s) {
      s.textContent = current;
    });
  }

  function run(name, fn) {
    try {
      fn();
    } catch (e) {
      if (window.console) console.warn('[PTSearch] ' + name, e);
    }
  }

  function initFilters() {
    if (!document.getElementById('CollectionFiltersForm')) return;
    run('chips', groupChips);
    run('clear-all', fixClearAll);
    run('count', updateCount);
    run('sort', relabelSort);
    run('keep-q', keepOriginal); // after the chip / clear-all rewrites above
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    run('popular', fixPopular);
    run('prefill', prefillResults);
    initFilters();
  });
  document.addEventListener('collection:rerendered', function () {
    run('prefill', prefillResults); // the search page box is inside the re-rendered section
    initFilters();
  });
  document.addEventListener('shopify:section:load', function (e) {
    run('popular', function () { fixPopular(e.target); });
    initFilters();
  });

  window.PTSearch = {
    mapQuery: mapQuery,
    fields: fields,
    unavailable: unavailable,
    searchUrl: searchUrl,
    config: config,
    i18n: i18n
  };
})();
